import { Component, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseEntityComponent, BaseEntityConfig, BnLoadingService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { RecuperacaoCredito } from 'src/app/model/recuperacao-credito.model';
import Utils from 'src/app/shared/fgi-utils';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { RecuperacaoCreditoService } from './recuperacao-credito.service';
import { ModalidadeService } from '../../../shared/services/modalidade.service';
import { TipoEstorno, TipoEstornoEnum } from 'src/app/model/tipo-estorno-enum';

@Component({
    selector: 'app-recuperacao-credito-detalhe',
    templateUrl: './recuperacao-credito-detalhe.component.html',
    styleUrls: ['./recuperacao-credito-detalhe.component.scss'],
    standalone: false
})
export class RecuperacaoCreditoDetalheComponent extends BaseEntityComponent<RecuperacaoCredito> implements OnInit {

    private agentesFinanceiros: AgenteFinanceiro[] = [];
    private idRecuperacaoCredito: number;
    public recuperacaoCredito: RecuperacaoCredito;
    public permissaoLinkN03: false;
    public podeReprovar = false;
    public ocorrencias: OcorrenciaValidacaoVO[] = [];
    public podeCancelar = false;
    public nomeModalidade: string;
    public podeLancarEstorno = false;
    public estornoManual: TipoEstornoEnum;
    tiposEstorno: TipoEstorno[] = [
        {
          nome: 'Não',
          valor: TipoEstornoEnum.NAO,
        },
        {
          nome: 'Parcial',
          valor: TipoEstornoEnum.PARCIAL,
        },
        {
          nome: 'Total',
          valor: TipoEstornoEnum.TOTAL,
        },
      ];

    @ViewChild('reprovacao') reprovacao: TemplateRef<any>;
    private motivoReprovacao: string;
    @ViewChild('reprovacaoBotoes') reprovacaoBotoes: TemplateRef<any>;

    @ViewChild('confirmEstorno') confirmEstorno: TemplateRef<any>;
    @ViewChild('confirmEstornoBotoes') confirmEstornoBotoes: TemplateRef<any>;

    constructor(protected injector: Injector,
                protected service: RecuperacaoCreditoService,
                private permissaoService: PermissaoService,
                private modalService: BnModalMessageService,
                private loadingService: BnLoadingService,
                private activatedRoute: ActivatedRoute,
                private modalidadeService: ModalidadeService
                ) {

        super(service, new BaseEntityConfig('/recuperacoes-credito'));
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
        this.config.rotaLista = '/recuperacoes-credito/pesquisa';
    }

    ngOnInit() {
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            this.permissaoLinkN03 = resp && (resp[ROLE_GESTOR_CONSULTA] || resp[ROLE_GESTOR_ENVIO]);
            this.podeReprovar = resp && (resp[ROLE_GESTOR_ENVIO]);
            this.podeCancelar = resp && (resp[ROLE_AGENTE_ENVIO]);
            this.podeLancarEstorno = resp && (resp[ROLE_GESTOR_ENVIO]);
        });
        this.route.params.subscribe(params => {
            this.idRecuperacaoCredito = params['id'];
            this.atualizarRecuperacaoCredito();
        });
        this.modalidadeService.modalidade$.subscribe((mod) => {
            for (let modalidade of this.modalidadeService.getModalidades()) {
                if (modalidade.sigla == mod) {
                  this.nomeModalidade = modalidade.nome;
                }
              }
        });
    }

    atualizarRecuperacaoCredito() {
      this.service.getRecuperacaoCredito(this.idRecuperacaoCredito).subscribe(resp => {
        this.recuperacaoCredito = resp;
        this.recuperacaoCredito.dataRecuperacao =this.ajustaCampoDate(this.recuperacaoCredito.dataRecuperacao);
        this.estornoManual = TipoEstornoEnum[this.recuperacaoCredito.estornoManual];
        console.log(`id estado: ${this.recuperacaoCredito.estado.id}`);
    });
    }

    reprovar() {
        this.motivoReprovacao = '';

        let tituloReprovacao = (this.podeReprovar ? 'Reprovação' : 'Exclusão') + ' da Recuperação de Crédito';

        this.modalService
                .abrir(tituloReprovacao, null, 'lg', this.reprovacao, this.reprovacaoBotoes)
            .result
                .then((recuperacaoReprovada: RecuperacaoCredito) => {
                    this.recuperacaoCredito = recuperacaoReprovada;
                    this.messageService.addMessage({
                        title: 'Sucesso',
                        type: 'CRUD_OPERATION',
                        level: messageLevel.SUCCESS,
                        message: 'Recuperação de crédito ' + (this.podeReprovar ? 'reprovada' : 'excluída') + ' com sucesso.'
                    });
                    this.ocorrencias = [];
                }, (reason) => {
                    console.log(reason);
                });
    }

    confirmaReprovacao() {
        this.loadingService.bloqueiaTela();
        this.service.cancelar(this.idRecuperacaoCredito, this.motivoReprovacao)
            .subscribe(solicitacaoHonraReprovada => {
                this.modalService.close(solicitacaoHonraReprovada);
                this.loadingService.liberaTela();
            }, error => {
                console.log(error);
                this.ocorrencias = this.service.ocorrencias;
                this.loadingService.liberaTela();
            });
    }

    cancelaReprovacao() {
        this.modalService.dismiss('abortou reprovação');
    }

    private nomeAgente(cnpj: string) {
        return Utils.nomeAgentePorCNPJ(cnpj, this.agentesFinanceiros);
    }

    private mesAno(valor?: string): string {
        return Utils.mesAno(valor);
    }
    
    ajustaCampoDate(data:any) {
        if (typeof data === 'string') {
          if (data.length == 10) {
            data += ' 00:00:00';
          }
          return new Date(data);
        }
    
        return data;
    }

    atualizaEstornoManual() {
      this.service.atualizarEstorno(this.recuperacaoCredito.id, this.estornoManual).subscribe(resp => {
        this.atualizarRecuperacaoCredito();
        this.modalService.dismiss();
      });
    }

  cancelarEstorno() {
    this.estornoManual = TipoEstornoEnum[this.recuperacaoCredito.estornoManual];
    this.modalService.dismiss();
  }

  abrirModalConfirmarAlteracaoEstorno() {
    this.modalService.abrir('Confirmação', null, 'lg', this.confirmEstorno, this.confirmEstornoBotoes);
  }
}
